module.exports = __webpack_public_path__ + "static/media/feature-02.946fadd6.jpg";